import DOMPurify from "dompurify";

/**
 * Forum HTML sanitizer — narrow allowlist matching the ForumRichEditor toolbar.
 *
 * Allowed inline marks:  <strong> <em> <a> <img>
 * Allowed block nodes:   <p> <br> <ul> <ol> <li> <blockquote>
 * Allowed attrs:         a[href|target|rel], img[src|alt]
 *
 * Blocked: scripts, iframes, style, on*= handlers, javascript:/data: URLs on
 * links, and any base64 embedded images (they can carry huge payloads and
 * bypass our size limit — the editor uploads to Object Store and references by
 * URL instead).
 */
export function sanitizeForumHtml(html) {
  if (!html) return "";
  const clean = DOMPurify.sanitize(String(html), {
    ALLOWED_TAGS: ["p", "br", "strong", "em", "ul", "ol", "li", "blockquote", "a", "img"],
    ALLOWED_ATTR: ["href", "target", "rel", "src", "alt"],
    // Force all links to open safely
    ADD_ATTR: ["target", "rel"],
    ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto):|\/|#)/i,
  });
  return clean;
}
